var HeaderComponent = (function () {
    function HeaderComponent() {
    }
    HeaderComponent.prototype.ngOnInit = function () {
    };
    return HeaderComponent;
}());
export { HeaderComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/layout/header/header.component.ts.pre-build-optimizer.js